import comp from "./AHFCompletedBanner";
export default comp;
